export const isSubscriptionCancelable = (campaignName?: string) =>
  !campaignName?.includes("T1_");
